module.exports = __webpack_public_path__ + "static/media/Licht_ruis.12d85e32.mp3";